export default "__VITE_ASSET__BsghZX23__"